import ChartTooltip from "components/Charts/ChartTooltip";

const BarTooltip = (values: any) => {
    const { bar } = values;

    console.log('?', values);

    return (
        <ChartTooltip
            label={`${bar.label}`}
            value={bar.formattedValue}
            color={bar.color}
        />
    )
}

export default BarTooltip